import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { FailedSolutions } from './components/FailedSolutions';
import { ProductReveal } from './components/ProductReveal';
import { MechanismSection } from './components/MechanismSection';
import { ForWhoSection } from './components/ForWhoSection';
import { ResultsSection } from './components/ResultsSection';
import { PricingSection } from './components/PricingSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-warm-900 text-cream-100 overflow-x-hidden selection:bg-amber-500/30 selection:text-amber-100" data-id="element-0">
      <main className="flex flex-col w-full" data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainSection data-id="element-3" />
        <FailedSolutions data-id="element-4" />
        <ProductReveal data-id="element-5" />
        <MechanismSection data-id="element-6" />
        <ForWhoSection data-id="element-7" />
        <ResultsSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <ClosingSection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}